module.exports = __webpack_public_path__ + "img/couples_10_V.3b7b32af.webp";